import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


export interface LoginListInput {
  userName: string;
  lastAuthentication: Date;
}
export interface LoginList{
  userName: string;
  ipAddress: string;
  lastAuthentication: string;
}
@Injectable({
  providedIn: 'root'
})

export class LoginActivityService {
  apiUrl = environment.apiURL;

  constructor(private http: HttpClient,private spinner:NgxSpinnerService) { }
  getLoginActivityResult(post: LoginListInput): Observable<LoginList> {
    this.spinner.show();
    return this.http.post<LoginList>(
      `${this.apiUrl}/rest/admin/login/report`,
      post
    );
  }
}
